import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Datatablenoresults from "layouts/Datatablenoresults";
import * as styleTable from "styles/datatable";
import CheckboxTable from "fragments/CheckboxTable";
// Custom Pagination Component with Footer
var CustomPagination = function(param) {
    var rowsPerPage = param.rowsPerPage, rowCount = param.rowCount, currentPage = param.currentPage, onChangePage = param.onChangePage, onChangeRowsPerPage = param.onChangeRowsPerPage, footer = param.footer;
    var maxPage = Math.ceil(rowCount / rowsPerPage);
    var handleFirst = function() {
        onChangePage(1);
    };
    var handlePrevious = function() {
        if (currentPage > 1) {
            onChangePage(currentPage - 1);
        }
    };
    var handleNext = function() {
        if (currentPage < maxPage) {
            onChangePage(currentPage + 1);
        }
    };
    var handleLast = function() {
        onChangePage(maxPage);
    };
    var startRow = rowCount === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
    var endRow = Math.min(currentPage * rowsPerPage, rowCount);
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            width: "100%"
        },
        children: [
            footer && footer(),
            /*#__PURE__*/ _jsxs("div", {
                style: {
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    padding: "12px 16px",
                    gap: "16px",
                    borderTop: "1px solid #e4e4e4"
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: "8px"
                        },
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                style: {
                                    fontSize: "14px",
                                    color: "#666"
                                },
                                children: "จำนวนรายการต่อหน้า"
                            }),
                            /*#__PURE__*/ _jsxs("select", {
                                value: rowsPerPage,
                                onChange: function(e) {
                                    return onChangeRowsPerPage(Number(e.target.value), currentPage);
                                },
                                style: {
                                    padding: "4px 24px 4px 8px",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                    backgroundColor: "white"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("option", {
                                        value: 5,
                                        children: "5"
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        value: 10,
                                        children: "10"
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        value: 25,
                                        children: "25"
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        value: 50,
                                        children: "50"
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        value: 100,
                                        children: "100"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        style: {
                            fontSize: "14px",
                            color: "#666"
                        },
                        children: [
                            startRow,
                            "-",
                            endRow,
                            " of ",
                            rowCount
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            display: "flex",
                            gap: "4px"
                        },
                        children: [
                            /*#__PURE__*/ _jsx("button", {
                                onClick: handleFirst,
                                disabled: currentPage === 1,
                                style: {
                                    padding: "6px 10px",
                                    border: "none",
                                    backgroundColor: "transparent",
                                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                                    color: currentPage === 1 ? "#ccc" : "#666",
                                    fontSize: "18px"
                                },
                                title: "หน้าแรก",
                                children: "⟪"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                onClick: handlePrevious,
                                disabled: currentPage === 1,
                                style: {
                                    padding: "6px 10px",
                                    border: "none",
                                    backgroundColor: "transparent",
                                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                                    color: currentPage === 1 ? "#ccc" : "#666",
                                    fontSize: "18px"
                                },
                                title: "หน้าก่อน",
                                children: "‹"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                onClick: handleNext,
                                disabled: currentPage >= maxPage,
                                style: {
                                    padding: "6px 10px",
                                    border: "none",
                                    backgroundColor: "transparent",
                                    cursor: currentPage >= maxPage ? "not-allowed" : "pointer",
                                    color: currentPage >= maxPage ? "#ccc" : "#666",
                                    fontSize: "18px"
                                },
                                title: "หน้าถัดไป",
                                children: "›"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                onClick: handleLast,
                                disabled: currentPage >= maxPage,
                                style: {
                                    padding: "6px 10px",
                                    border: "none",
                                    backgroundColor: "transparent",
                                    cursor: currentPage >= maxPage ? "not-allowed" : "pointer",
                                    color: currentPage >= maxPage ? "#ccc" : "#666",
                                    fontSize: "18px"
                                },
                                title: "หน้าสุดท้าย",
                                children: "⟫"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default function DataTableLayout(_param) {
    var item = _param.item, handleRowSelected = _param.handleRowSelected, dataRowSelected = _param.dataRowSelected, columns = _param.columns, isSelectRows = _param.isSelectRows, _param_sortFieldId = _param.sortFieldId, sortFieldId = _param_sortFieldId === void 0 ? "" : _param_sortFieldId, _param_sortAsc = _param.sortAsc, sortAsc = _param_sortAsc === void 0 ? true : _param_sortAsc, _param_PerPage = _param.PerPage, PerPage = _param_PerPage === void 0 ? 10 : _param_PerPage, _param_footer = _param.footer, footer = _param_footer === void 0 ? null : _param_footer, props = _object_without_properties(_param, [
        "item",
        "handleRowSelected",
        "dataRowSelected",
        "columns",
        "isSelectRows",
        "sortFieldId",
        "sortAsc",
        "PerPage",
        "footer"
    ]);
    var _useState = _sliced_to_array(useState(item || []), 2), sortedItems = _useState[0], setSortedItems = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        selectedColumn: null,
        sortDirection: sortAsc ? "asc" : "desc"
    }), 2), sortState = _useState1[0], setSortState = _useState1[1];
    var getColumnValue = function(row, selectedColumn) {
        if (!selectedColumn) return row;
        if (typeof selectedColumn.selector === "function") {
            return selectedColumn.selector(row);
        }
        if (selectedColumn.selector) {
            return row === null || row === void 0 ? void 0 : row[selectedColumn.selector];
        }
        return row;
    };
    var normalizeValue = function(value) {
        if (value === null || value === undefined || value === "") return null;
        if (typeof value === "number") return value;
        if (_instanceof(value, Date)) return value.getTime();
        if (typeof value === "string") return value.trim().toLowerCase();
        return value;
    };
    var sortItems = function(sourceItems, selectedColumn, sortDirection) {
        var rows = _to_consumable_array(sourceItems || []);
        if (!selectedColumn) {
            return rows;
        }
        if (typeof selectedColumn.sortFunction === "function") {
            return rows.sort(function(rowA, rowB) {
                var result = selectedColumn.sortFunction(rowA, rowB);
                return sortDirection === "asc" ? result : result * -1;
            });
        }
        return rows.sort(function(rowA, rowB) {
            var valueA = normalizeValue(getColumnValue(rowA, selectedColumn));
            var valueB = normalizeValue(getColumnValue(rowB, selectedColumn));
            if (valueA === valueB) return 0;
            if (valueA === null) return sortDirection === "asc" ? -1 : 1;
            if (valueB === null) return sortDirection === "asc" ? 1 : -1;
            if (valueA > valueB) {
                return sortDirection === "asc" ? 1 : -1;
            }
            return sortDirection === "asc" ? -1 : 1;
        });
    };
    useEffect(function() {
        setSortedItems(sortItems(item || [], sortState.selectedColumn, sortState.sortDirection));
    }, [
        item,
        sortState.selectedColumn,
        sortState.sortDirection
    ]);
    var handleSort = function(selectedColumn, sortDirection, sortedRows) {
        setSortState({
            selectedColumn: selectedColumn,
            sortDirection: sortDirection
        });
    };
    return /*#__PURE__*/ _jsx(DataTable, _object_spread({
        columns: columns,
        data: sortedItems,
        customStyles: styleTable.customStyles,
        selectableRows: isSelectRows,
        selectableRowsComponent: CheckboxTable,
        pagination: true,
        paginationComponent: function(paginationProps) {
            return /*#__PURE__*/ _jsx(CustomPagination, _object_spread_props(_object_spread({}, paginationProps), {
                footer: footer
            }));
        },
        onSelectedRowsChange: handleRowSelected,
        selectableRowSelected: dataRowSelected,
        noDataComponent: /*#__PURE__*/ _jsx(Datatablenoresults, {}),
        persistTableHead: true,
        paginationPerPage: PerPage,
        paginationRowsPerPageOptions: [
            5,
            10,
            25,
            50,
            100
        ],
        onSort: handleSort,
        defaultSortFieldId: sortFieldId || undefined,
        defaultSortAsc: sortAsc
    }, props));
}
